import styled, { css } from 'styled-components';
import { redColor } from 'js/config/style';

const statusStyle = {
  expired: css`
    font-weight: bold;
    color: ${redColor};
  `,
  warn: css`
    font-weight: 500;
    color: #ff6c00;
    font-family: monospace;
  `,
  normal: css`
    font-weight: 500;
  `,
};

export default styled.span`
  ${({ status }) => statusStyle[status]}
`;
